import Selector from 'components/Selector'

type Industry = {
  name: string
  description: string
}

const industries: Array<Industry> = [
  {
    name: 'Energy',
    description: '(Energy equipment and services, oil/gas/consumable fuels)',
  },
  {
    name: 'Materials',
    description: '(Chemicals, construction materials, containers & packaging, metals & mining, paper & forest product)',
  },
  {
    name: 'Industrials',
    description: '(Capital goods, commercial services & professional services, transportation)',
  },
  {
    name: 'Consumer discretionary',
    description: '(Automobiles & components, consumer durables & apparel, consumer services, retailing)',
  },
  {
    name: 'Consumer Staples',
    description: '(Food & staples retailing, food, beverage & tobacco, household & personal products)',
  },
  {
    name: 'Healthcare',
    description: '(Health care equipment & services, pharmaceuticals, biotechnology & lifesciences)',
  },
  {
    name: 'Financials',
    description: '(Banks, diversified financials, insurance)',
  },
  {
    name: 'Technology',
    description: '(Software & services, hardware & equipment, semiconductors & equipment)',
  },
  {
    name: 'Communications services',
    description: '(Telecomm services, Media & entertainment)',
  },
  {
    name: 'Utilities',
    description: '',
  },
  {
    name: 'Real estate',
    description: '',
  },
  {
    name: 'Other',
    description: '',
  },
]

const IndustryPicker = ({
  value,
  setIndustry,
  disabled,
}: {
  value: string
  setIndustry: (industry: string) => void
  disabled: boolean
}) => {
  return (
    <Selector
      placeholder="Select an industry"
      id="industry-picker"
      label="Industry"
      option={value}
      options={industries.map((i) => i.name)}
      setOption={(option: any) => {
        setIndustry(option)
      }}
      isDarkBackdrop={true}
      width="240px"
      disabled={disabled}
    />
  )
}

export default IndustryPicker
